/// <reference types="vite/client" />
import { queryOptions, useQuery, UseQueryResult } from '@tanstack/react-query';
import useParties from '../useParties/useParties';
import { spiceroad } from '..';

export interface GetInstantFundingTermsAndConditionsProps {
  termsAndConditionsText: string | undefined;
  isLoading: boolean;
  isError: any;
  query: UseQueryResult<any>;
}

const getInstantFundingTerms = (locId: string) =>
  spiceroad
    .get(`/v1/locs/instantfunding/getterms/${locId}`)
    .then((res) => res.data);

export const getInstantFundingTermsOpts = (locId: string) =>
  queryOptions({
    queryKey: ['instantFundingTerms', locId],
    queryFn: () => getInstantFundingTerms(locId),
  });

export function getInstantFundingTermsAndConditions(): GetInstantFundingTermsAndConditionsProps {
  const { hasLOC, isLoadingParties, isErrorParties } = useParties();
  const query = useQuery({
    ...getInstantFundingTermsOpts(hasLOC!),
    enabled: !!hasLOC,
  });
  const { data, error, isLoading } = query;

  return <GetInstantFundingTermsAndConditionsProps>{
    termsAndConditionsText: data?.termsAndConditions?.termsAndConditionsText,
    isLoading: isLoadingParties || isLoading,
    isError: isErrorParties || error,
    query,
  };
}

export default getInstantFundingTermsAndConditions;
